import React from 'react';

const links = [
  {
    title: 'Engineering Learning & Career',
    description: 'Development hub',
    icon: '🎓',
  },
  {
    title: 'Technology Support Hub',
    description: '',
    icon: '💻',
  },
  {
    title: 'Cloud Learning',
    description: 'Learn and master everything in LSEG Cloud',
    icon: '☁️',
  },
  {
    title: 'Service Now',
    description: '',
    icon: '🔧',
  },
  {
    title: 'Front Door',
    description: 'Support for Developers',
    icon: '🚪',
  },
  {
    title: 'Developer Desktops',
    description: '',
    icon: '🖥️',
  },
];

export const UsefulLinks: React.FC = () => {
  return (
    <div className="bg-white rounded-lg shadow p-6">
      <h2 className="text-xl font-semibold mb-4">🔗 Useful Links</h2>
      <div className="grid grid-cols-2 gap-4">
        {links.map((link) => (
          <button
            key={link.title}
            className="flex items-start p-4 hover:bg-gray-50 rounded-lg transition-colors text-left"
          >
            <span className="text-2xl mr-3">{link.icon}</span>
            <div>
              <h3 className="font-medium text-gray-900">{link.title}</h3>
              {link.description && (
                <p className="text-sm text-gray-600">{link.description}</p>
              )}
            </div>
          </button>
        ))}
      </div>
    </div>
  );
};